import React from 'react';

function AboutPage({ readmeContent }) {
  return (
    <div>
      <h2>About Worthy</h2>
      <p>Learn more about this application and its features.</p>      
    </div>
  );
}


export default AboutPage;
